module.exports = __webpack_public_path__ + "img/704_2.c852cdd3.jpg";